<template>
    <div class="barrier" ref="barrier" @click="onClick"><slot></slot></div>
</template>

<script>
export default {
    methods: {
        onClick(e) {
            if (e.target === this.$refs.barrier) {
                this.$emit("click", e);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.barrier {
    z-index: 10000;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #00000088;
}
</style>



// WEBPACK FOOTER //
// modal-barrier.vue?2198aa31